module.exports = __webpack_public_path__ + "static/media/default-avatar.f653841f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/default-avatar.png
// module id = 589
// module chunks = 0